export default __webpack_public_path__ + "static/media/Holidaze-logo-black.8ab65424.png";